import HtmlDiff from './Diff';
const diff = (oldText, newText, { blocksExpression } = {}) => {
    const finder = new HtmlDiff(oldText, newText);
    if (blocksExpression) {
        blocksExpression.forEach(block => finder.addBlockExpression(block));
    }
    return finder.diff();
};
export default diff;
//# sourceMappingURL=index.js.map